import { Component, Watch, Vue } from 'vue-property-decorator'
import { Loading } from 'src/types/models/index'

@Component
export default class CommonMixin extends Vue {
  globalLoading: Loading = 0

  @Watch('globalLoading')
  emitLoading(val: Loading) {
    const loadingConfig = {
      spinnerColor: 'primary',
      backgroundColor: 'bg',
      spinnerSize: 50
    }
    val ? this.$q.loading.show(loadingConfig) : this.$q.loading.hide()
  }

  logout() {
    this.$Auth
      .signOut()
      .then(() => {
        this.$q.localStorage.clear()
        if (this.$route.name !== 'signIn') this.$router.push({ name: 'signIn' })
      })
      .catch((e: any) => this.notifyNegative('errors.failed_req', e))
  }

  notifyPositive(message: string) {
    this.$q.notify({
      color: 'positive',
      icon: 'fal fa-thumbs-up',
      message: this.$i18n.tc(message)
    })
  }
  notifyNegative(message: string, err?: any) {
    this.$q.notify({
      color: 'negative',
      icon: 'fal fa-thumbs-down',
      message: this.$i18n.tc(message)
    })
    if (err) console.error(err)
  }
}
